<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
        <div class="md-toolbar-section-start">
          <img :src="logo" />
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-round md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

<!--          <div-->
<!--            class="md-collapse"-->
<!--            :class="{ 'off-canvas-sidebar': responsive }"-->
<!--          >-->
<!--            <md-list>-->
<!--              <md-list-item @click="registerLinkClick">-->
<!--                <md-icon>person_add</md-icon>-->
<!--                Register-->
<!--              </md-list-item>-->
<!--              <md-list-item @click="loginLinkClick">-->
<!--                <md-icon>fingerprint</md-icon>-->
<!--                login-->
<!--              </md-list-item>-->
<!--            </md-list>-->
<!--          </div>-->
        </div>
      </div>
    </md-toolbar>
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"
      >
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container md-offset">
            <div class="copyright text-center">
              &copy; {{ new Date().getFullYear() }}
              <a href="https://www.askuni.com" target="_blank">Askuni</a>
            </div>
            <div class="copyright text-center">
              <md-button class="md-simple md-just-icon md-facebook md-white">
                <a href="https://www.facebook.com/askunicom/" target="_blank"><i class="fab fa-facebook"></i></a>
              </md-button>
              <md-button class="md-simple md-just-icon md-twitter md-white">
                <a href="https://twitter.com/askunicom" target="_blank"><i class="fab fa-twitter"></i></a>
              </md-button>
              <md-button class="md-simple md-just-icon md-facebook md-white">
                <a href="https://www.instagram.com/askunicom/?hl=tr" target="_blank"><i class="fab fa-instagram"></i></a>
              </md-button>
              <md-button class="md-simple md-just-icon md-facebook md-white">
                <a href="https://tr.linkedin.com/company/askuni-com" target="_blank"><i class="fab fa-linkedin"></i></a>
              </md-button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    },
    logo: {
      type: String,
      default: "/img/logo_white_min.png"
    },
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear()
    };
  },
  computed: {
    setBgImage() {
      let login_images = [
          "/img/login-1.jpg",
          "/img/login-2.jpg",
          "/img/login-3.jpg",
          "/img/login-4.jpg",
          "/img/login-5.jpg",
      ]
      let images = {
        Pricing: "/img/bg-pricing.jpg",
        Login: login_images[Math.floor(Math.random()*login_images.length)],
        Register: "/img/register.jpg",
        Lock: "/img/lock.jpg"
      };
      return {
        backgroundImage: `url(${images[this.$route.name]})`
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    }
  },
  methods: {
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    loginLinkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
      this.$router.push({ name: "Login" });
    },
    // registerLinkClick() {
    //   if (
    //     this.autoClose &&
    //     this.$sidebar &&
    //     this.$sidebar.showSidebar === true
    //   ) {
    //     this.$sidebar.displaySidebar(false);
    //   }
    //   this.$router.push({ name: "Register" });
    // },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
